    import { useEffect } from "react";
import React from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import Img1 from "./img/webp/1Plafond tendu circulaire avec éclairage LED intégré, design architectural moderne pour espace professionnel – UNIK SYSTEM.webp"
import Img2 from "./img/webp/13Façade architecturale moderne de la gare Rabat Agdal avec habillage et éclairage intégré.webp"
import Img3 from "./img/webp/34Plafond architectural moderne.webp"
import Img4 from "./img/webp/4.webp"

export default function StickyDemo() {
  useEffect(() => {
    AOS.init({
      duration: 1500,
      once: true,
    });
  }, []);

  return (
    <>
      <div className="usstretch-section">

  {/* ===== BLOC 1 ===== */}
  <div className="usstretch-row">
    <div className="usstretch-text">
      <h3 data-aos="fade-right">
        <span className="subtitle-us">US</span> LIGHT
      </h3><br/>
      <h5 data-aos="fade-up">Avec rétroéclairage</h5>

      <p data-aos="fade-up">
        Des plafonds lumineux conçus pour les espaces publics et privés,
        créant des ambiances originales, modernes et design. Idéal pour
        les lieux de vie, de détente ou d’accueil.
      </p>

      <h6 data-aos="fade-up">Avantages :</h6>
      <ul data-aos="fade-up">
        <li>✨ Ambiance chaleureuse et relaxante</li>
        <li>💡 Éclairage homogène et diffus</li>
        <li>🎨 Design moderne et esthétique</li>
        <li>🔌 Dissimulation des câbles et équipements</li>
        <li>⚡ Compatible LED basse consommation</li>
      </ul>

      <a data-aos="fade-up" href="/plafond-lumineux-led-maroc" className="learn-more-link">
        En savoir plus <span className="arrow">→</span>
      </a>
    </div>

    <div className="usstretch-image" data-aos="fade-up" data-aos-duration="3000">
      <img src={Img1} alt="US Light plafond lumineux" />
    </div>
  </div>

  {/* ===== BLOC 2 (inversé) ===== */}
  <div className="usstretch-row">
    <div className="usstretch-image" data-aos="fade-up" data-aos-duration="3000">
      <img src={Img2} alt="US Light éclairage architectural" />
    </div>

    <div className="usstretch-text">
      <h3 data-aos="fade-up-right">
        <span className="subtitle-us">US</span> LIGHT
      </h3><br/>
      <h5 data-aos="fade-up">Éclairage architectural</h5>

      <p data-aos="fade-up">
        Solutions d’éclairage intégrées dans les plafonds et murs tendus,
        permettant de valoriser les volumes architecturaux et d’améliorer
        le confort visuel des espaces.
      </p>

      <h6 data-aos="fade-up">Avantages :</h6>
      <ul data-aos="fade-up">
        <li>🏗️ Mise en valeur des volumes</li>
        <li>💡 Diffusion lumineuse uniforme</li>
        <li>🎯 Confort visuel optimal</li>
        <li>⚙️ Intégration technique discrète</li>
        <li>🔋 Solutions LED économiques</li>
      </ul>

      <a data-aos="fade-up" href="/eclairage-architectural-maroc" className="learn-more-link">
        En savoir plus <span className="arrow">→</span>
      </a>
    </div>
  </div>

  {/* ===== BLOC 3 ===== */}
  <div className="usstretch-row">
    <div className="usstretch-text">
      <h3 data-aos="fade-right">
        <span className="subtitle-us">US</span> LIGHT
      </h3><br/>
      <h5 data-aos="fade-up">Solutions lumineuses décoratives</h5>

      <p data-aos="fade-up">
        Plafonds et murs lumineux sur mesure pour créer des ambiances
        décoratives uniques dans les hôtels, restaurants, commerces
        et espaces résidentiels.
      </p>

      <h6 data-aos="fade-up">Avantages :</h6>
      <ul data-aos="fade-up">
        <li>🌈 Ambiances lumineuses personnalisées</li>
        <li>🎨 Intégration décorative élégante</li>
        <li>🏨 Idéal pour hôtels, spas et commerces</li>
        <li>💡 Lumière douce et uniforme</li>
        <li>🛠️ Installation propre et rapide</li>
      </ul>

      <a data-aos="fade-up" href="/eclairage-decoratif-maroc" className="learn-more-link">
        En savoir plus <span className="arrow">→</span>
      </a>
    </div>

    <div className="usstretch-image" data-aos="fade-up" data-aos-duration="3000">
      <img src={Img3} alt="US Light plafond décoratif lumineux" />
    </div>
  </div>
  {/* ===== BLOC 4 ===== */}
<div className="usstretch-row reverse">

  

  <div className="usstretch-text">
    <h3 data-aos="fade-right">
      <span className="subtitle-us">US</span> LIGHT BOX
    </h3>
    <br />
    <h5 data-aos="fade-up">Caisson lumineux sur mesure</h5>

    <p data-aos="fade-up">
      Le caisson lumineux US LIGHT BOX est la solution idéale pour
      mettre en valeur vos visuels grâce à un éclairage homogène et
      performant. Fabriqué sur mesure, il s’adapte à toutes les
      configurations pour la publicité, la signalétique ou la
      communication corporate.
    </p>

    <h6 data-aos="fade-up">Avantages :</h6>
    <ul data-aos="fade-up">
      <li>💡 Éclairage EDGE LED haute performance</li>
      <li>🖼️ Mise en valeur optimale des visuels</li>
      <li>🔄 Changement de toile facile par jonc</li>
      <li>📐 Caisson aluminium sur mesure</li>
      <li>⚡ Installation rapide et durable</li>
    </ul>

    <a
      data-aos="fade-up"
      href="/lightbox-maroc"
      className="learn-more-link"
    >
      En savoir plus <span className="arrow">→</span>
    </a>
  </div>
  <div
    className="usstretch-image"
    data-aos="fade-up"
    data-aos-duration="3000"
  >
    <img src={Img4} alt="US Light Box caisson lumineux sur mesure" />
  </div>

</div>


</div>

      
    </>
  );
}
